<template>
  <el-row id="app" :class="{'html_gary': html_gary}">
    <router-view class="tabs-fixed-top" />
  </el-row>
</template>

<script>
import { showHtmlGray } from '@/api'

export default {
  name: 'App',
  data() {
    return {
      html_gary: false
    }
  },
  created() {
    // 是否设置灰色滤镜，一般公祭日之类在后台设置
    showHtmlGray()
      .then(rep => {
        if (rep) {
          const b = rep.html_gray
          if (b && (b + '') === '1') {
            this.html_gary = true
            return
          }
        }
        this.html_gary = false
      })
  }
}
</script>
<style lang="scss">
html, body{
  font-family: '微软雅黑 Regular','微软雅黑';
  line-height: 1.5;
}

p{
  margin-block-start: 0;
  margin-block-end: 0;
}

.html_gary {
  // 变灰
  -webkit-filter: grayscale(100%);
  filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}

/*大屏字体*/
.main_title{
  font-size: 20px!important;
}
.title{
  font-size: 18px!important;
}
.text{
  font-size: 14px!important;
}
.text_small{
  font-size: 12px!important;
}

/*小屏字体*/
.phone_title{
  font-size: 45px!important;
}
.phone_text{
  font-size: 35px!important;
}

/*文本设置*/
.text_center{
  text-align: center;
}
.text_left{
  text-align: left;
}

.el-scrollbar__wrap{
  overflow-x: hidden;
}
:focus{
  outline:0;
}

.avatar-uploader{
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
